import { FC } from 'react';
import { DetailsBooking } from 'types';
import { ContentHeading } from 'components/Typography';
import HotelDetailsCard from './HotelDetailsCard';
import BookingDetailsCard from './BookingDetailsCard';

interface BookingDetailsProps {
  booking: DetailsBooking;
}

const BookingDetails: FC<BookingDetailsProps> = ({ booking }) => (
  <>
    <ContentHeading>Hotel details</ContentHeading>
    <HotelDetailsCard booking={booking} />

    <ContentHeading>Booking details</ContentHeading>
    <BookingDetailsCard booking={booking} />
  </>
);

export default BookingDetails;
